<template>
  <v-container grid-list-xs class="mt-4" style="max-width: 1070px">
    <v-row align="center" justify="center">
      <v-col cols="12" align="center" >
        <div>
          <h1>Preguntas Frecuentes</h1>
        </div>
      </v-col> 
    </v-row>
    <v-row v-if="preguntas" align="center" justify="center">
      <v-col cols="12" align="center">
        <v-expansion-panels focusable style="width: 700px">
          <v-expansion-panel v-for="(item, i) in itemsPreguntas" :key="i">
            <v-expansion-panel-header class="text-h6">{{item.pregunta}}</v-expansion-panel-header>
              <v-expansion-panel-content class="mt-3">
                {{item.respuesta}}
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row v-if="!preguntas" align="center" justify="center">
      <v-col cols="12" align="center">
        <v-alert type="info" width="300">No hay preguntas para mostrar</v-alert>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <v-btn color="success" rounded @click="nuevaPregunta = true">Agregar Pregunta</v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="nuevaPregunta" width="600" persistent>
      <v-card>
        <v-toolbar dark style="background-color: #1c3d6c" >
          <v-btn icon color="white" @click="closeVentana()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Nueva Pregunta</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5 pb-0">
          <v-container>
            <v-form ref="formPregunta" v-model="validP" @submit.prevent> 
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field outlined label="Pregunta" v-model="pregunta" :rules="[rules.required]" :maxlength="50"></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field outlined label="Nombre" v-model="nombre" :rules="[rules.required]" :maxlength="50"></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field outlined label="Apellidos" v-model="apellidos" :rules="[rules.required]" :maxlength="50"></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field outlined label="Correo" v-model="correo" :rules="[rules.required, rules.validEmail]" :maxlength="50"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-5 mr-5">
            <v-spacer></v-spacer>
            <v-btn :disabled="!validP" color="success" class="mr-4" type="submit" @click="agregarPregunta()">Enviar Pregunta</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogClose" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5 text-center">¿Estas seguro de cerrar esta ventana?, los datos ingresados se eliminaran</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancelarClose">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="cerrarVentana">Continuar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <v-snackbar v-model="mensaje" centered :color="color" timeout="2000"> 
        <v-row justify="center" align="center">
          <v-col cols="3" class="text-center">
            <v-icon size="50">mdi-check-circle-outline</v-icon>
          </v-col>
          <v-col cols="9" class="text-h6 text-center">
            {{texto}}
          </v-col>
        </v-row>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import { createForm } from '@/general'


export default {
  metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Contacto y FAQ - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },
  data () {
    return {
      itemsPreguntas: [],
      preguntas: false,
      nuevaPregunta: false,
      validP: '',

      pregunta: '',
      nombre: '',
      apellidos: '',
      correo: '',
      rules: {
        required: v => !!v || 'Este dato no puede estar vacio',
        validEmail: v => /\S+@\S+\.\S+/.test(v) || 'Email inválido',
      },
      dialogClose: false,

      // variables para las alertas
      mensaje: false,
      texto: '',
      color: '',
    }
  },

  created(){
    this.getFaq()
  },

  methods:{
    async getFaq(){
      let response = await this.faq(createForm({operacion: '1'}));
      delete response['state'];
      if(Object.keys(response).length > 0 ){
        this.preguntas = true
        Object.entries(response).forEach(([key, value]) => {
          this.itemsPreguntas.push(value);
        });
      }else{
        this.preguntas = false
      } 
    },

    faq(data){
      return new Promise((resolve, reject) => {
        axios.post('faq.php', data)
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

    closeVentana(){
      this.dialogClose = true
    },

    cancelarClose(){
      this.dialogClose = false
    },

    cerrarVentana(){
      this.dialogClose = false
      this.nuevaPregunta = false
      this.$refs.formPregunta.reset()
    },

    async agregarPregunta(){
      if(this.$refs.formPregunta.validate() == true){
        let response = await this.modificaFaq(createForm({pregunta: this.pregunta,
                                                          nombre: this.nombre,
                                                          apellidos: this.apellidos,
                                                          correo: this.correo,
                                                          operacion: '2'}))
        if(response.state == '1'){
          this.mensaje = true
          this.texto = 'Pregunta enviada con éxito'
          this.color = 'success'
          this.cerrarVentana()
          setTimeout(()=>{
            this.itemsPreguntas = []
            this.getFaq()
          },2000)
        }else if (response.state == '2'){
          this.mensaje = true
          this.texto = 'Error al agregar la pregunta, tus datos no pueden ser vacios'
          this.color = 'error'
          this.cerrarVentana()
        }else if (response.state == '3' || response.state == '4'){
          this.mensaje = true
          this.texto = 'Se produjo un error interno, intentalo más tarde'
          this.color = 'error'
          this.cerrarVentana()
        }else if (response.state == '6' ){
          this.mensaje = true
          this.texto = 'No se pudo enviar la pregunta, intentalo más tarde'
          this.color = 'error'
          this.cerrarVentana()
        }
        
      }
    },

    modificaFaq(data){
      return new Promise((resolve, reject) => {
        axios.post('faq.php', data)
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

  }
}
</script>
